import React, { useMemo } from 'react';
import { Card, CardBody, Col, Row } from 'react-bootstrap';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { TableResponsive } from '../../../components/common/TableResponsive';
import {
    useMeetingArrange,
    MeetingArrangeHeader,
    getMeetingArrangeColumns
} from './MeetingArrange/index';
import './EnquiryList/EnquiryList.css';

const MeetingArrange = () => {
    const {
        filteredMeetings,
        isLoading,
        selectedDate,
        setSelectedDate,
        todayFormatted,
        selectedUser,
        setSelectedUser,
        userList,
        selectedDistrict,
        setSelectedDistrict,
        districtList,
        searchTerm,
        setSearchTerm,
        stats,
        handleFollowSuccess,
        handleReport
    } = useMeetingArrange();

    const columns = useMemo(
        () => getMeetingArrangeColumns({ handleReport, handleFollowSuccess }),
        [handleReport, handleFollowSuccess]
    );

    return (
        <>
            <BreadCrumb title="Meeting Arrange" prevPage="Enquiry" prevPath="/enquiry" />
            <Row>
                <Col xs={12}>
                    <Card className="border-0 shadow-sm">
                        {/* Header: User filter, Date picker, District filter, Search & Stats */}
                        <MeetingArrangeHeader
                            selectedDate={selectedDate}
                            setSelectedDate={setSelectedDate}
                            todayFormatted={todayFormatted}
                            selectedUser={selectedUser}
                            setSelectedUser={setSelectedUser}
                            userList={userList}
                            selectedDistrict={selectedDistrict}
                            setSelectedDistrict={setSelectedDistrict}
                            districtList={districtList}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            stats={stats}
                        />

                        {/* Table Responsive Body */}
                        <CardBody className="p-0 p-md-3">
                            <TableResponsive
                                isLoading={isLoading}
                                columns={columns}
                                data={filteredMeetings}
                                noRecord="No Meeting Arrange Records Found for Selected Filter"
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default MeetingArrange;
